import { Card, CardBody } from '@nextui-org/react'
import { FC } from 'react'
import { useTankStore } from '../../store/tank/useTankStore'
import EmptyCard from './EmptyCard'

interface EmptyCardContainerProps {
  emptyTankIds?: string[]
}

/**
 * EmptyCardContainer Component
 *
 * Displays tanks that are empty (no schoolId assigned).
 *
 * @param emptyTankIds - Array of tank IDs without schoolId
 */
export const EmptyCardContainer: FC<EmptyCardContainerProps> = ({ emptyTankIds = [] }) => {
  const tanks = useTankStore((state) => state.tanks)

  const createEmptyBlocks = emptyTankIds
    .filter((tankId) => tankId in tanks)
    .sort((a, b) => {
      const nameA = tanks[a]?.name?.toLowerCase() || ''
      const nameB = tanks[b]?.name?.toLowerCase() || ''
      return nameA.localeCompare(nameB)
    })
    .map((tankId) => {
      const emptyTank = tanks[tankId]
      return (
        <div key={tankId} className="mx-2 my-1 empty-card-item">
          <EmptyCard tankName={emptyTank.name} tankId={tankId} />
        </div>
      )
    })

  return (
    <div>
      {emptyTankIds.length > 0 ? (
        <div className="mt-6 md:mt-10" data-testid="empty-tanks">
          <div className="flex justify-between my-1">
            <div className="flex justify-start gap-[1.25rem]">
              <div className="ml-1 mb-2 text-tdplindigo text-[1.25rem]">Empty Tanks</div>
            </div>
          </div>
          <Card className="bg-white border-1 border-tdpldarkgrey border-opacity-50 rounded-lg" shadow="none" radius="lg" style={{ borderRadius: '0.75rem' }}>
            <CardBody className="flex flex-wrap flex-row justify-start empty-card-container">
              {createEmptyBlocks}
            </CardBody>
          </Card>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default EmptyCardContainer
